// extracted by mini-css-extract-plugin
export var dot = "_qu-2";
export var wave = "_qu-0";
export var waveSmall = "_qu-1";